import { gql } from '@apollo/client';
import { useMutation } from '@apollo/client';

const ABORT_EVENT_MUTATION = gql`
  mutation ditAbortEvent($eventId: ID!, $message: String!) {
    ditAbortEvent(eventId: $eventId, message: $message) {
      message
    }
  }
`;

export const useDitAbortEvent = () => {
  const [abortEvent, { data, loading, error }] = useMutation(ABORT_EVENT_MUTATION);
  return {
    abortDitEvent: async ({ eventId, message }) => {
      return await abortEvent({
        variables: {
          eventId,
          message,
        },
      });
    },
    message: data?.ditAbortEvent.message,
    loading,
    error,
  };
};
